import * as types from './constants';

// Verify Account Phone
export const verifyAccountPhoneRequest = data => (
  { type: types.VERIFY_ACCOUNT_PHONE_REQUEST, payload: data }
);

export const verifyAccountPhoneDone = data => (
  { type: types.VERIFY_ACCOUNT_PHONE_DONE, payload: data }
);

export const verifyAccountPhoneFailed = errors => (
  { type: types.VERIFY_ACCOUNT_PHONE_FAILED, payload: errors }
);